const STORAGE_KEY = 'pending-signup-payment-setup';

const canUseSessionStorage = () => typeof window !== 'undefined' && window.sessionStorage;

const parseStoredValue = value => {
    if (!value) return null;

    try {
        return JSON.parse(value);
    } catch (error) {
        window.sessionStorage.removeItem(STORAGE_KEY);
        return null;
    }
};

export const clearPendingPaymentSetup = () => {
    if (!canUseSessionStorage()) return;
    window.sessionStorage.removeItem(STORAGE_KEY);
};

export const savePendingPaymentSetup = ({ customerId, paymentSetup } = {}) => {
    if (!canUseSessionStorage()) return;

    if (!customerId || !paymentSetup?.clientSecret) {
        clearPendingPaymentSetup();
        return;
    }

    window.sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
            customerId,
            paymentSetup
        })
    );
};

export const getPendingPaymentSetup = customerId => {
    if (!canUseSessionStorage() || !customerId) return null;

    const storedValue = parseStoredValue(window.sessionStorage.getItem(STORAGE_KEY));

    if (!storedValue || storedValue.customerId !== customerId) {
        return null;
    }

    return storedValue.paymentSetup || null;
};

export const takePendingPaymentSetup = customerId => {
    const paymentSetup = getPendingPaymentSetup(customerId);

    if (paymentSetup) {
        clearPendingPaymentSetup();
    }

    return paymentSetup;
};
